export const routeList = {
  noDeepLinkUrl: "/",
  homePage: "/home",
  applyCreme: "/apply",
  gallery: "/gallery",
  contact: "/contact",
  other: "/*",
};
